import { AppYeuCauHoTroSelectRequest } from "../models/request/app-phuhuynh/AppYeuCauHoTroSelectRequest";
import { AppYeuCauHoTroUpdateRequest } from "../models/request/app-phuhuynh/AppYeuCauHoTroUpdateRequest";
import { apiClient } from "./apiClient";

export const API_APP_YEUCAUHOTRO_PATH = "app-yeu-cau-ho-tro"
export const appYeuCauHoTroApi = {
    selectAsync: (request: AppYeuCauHoTroSelectRequest) => {
        let queryModel: any = request ? { ...request } : undefined;
        let queryString = queryModel ? new URLSearchParams(queryModel) : undefined;
        return apiClient.get(`${API_APP_YEUCAUHOTRO_PATH}/select${queryString ? `?${queryString}` : ''}`)
    },
    selectDetailAsync: (id: number) => {
        return apiClient.get(`${API_APP_YEUCAUHOTRO_PATH}/${id}`)
    },
    updateKetQuaAsync: (request: AppYeuCauHoTroUpdateRequest) => {
        return apiClient.put(`${API_APP_YEUCAUHOTRO_PATH}`, request)
    }
};